import ApplicationsRequests from './applications';
import AssetsRequests from './assets';
import AuthRequests from './auth';
import AuthFormsRequests from './authForms';
import FormsRequests from './forms';
import MFARequests from './mfa';
import PublicSettingsRequests from './publicSettings';
import UsersRequests from './users';

const AccountClientRequests = {
	Assets: AssetsRequests,
	Auth: AuthRequests,
	Users: UsersRequests,
	Applications: ApplicationsRequests,
	Forms: FormsRequests,
	MFA: MFARequests,
	AuthForms: AuthFormsRequests,
	PublicSettings: PublicSettingsRequests,
};

export default AccountClientRequests;
